import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { carousel as orgConfig } from 'org/configs/modules.config';

/*
  The embla carousel API is extended with these custom options:
  - hasArrows:          boolean   Determines if arrows are displayed
  - hasDots:            boolean   Determines if navigation dots are displayed
  - hasCounter:         boolean   Determines if a slides counter is displayed
  - isClipped:          boolean   Determines if carousel edge should be aligned with viewport.
                                  Usually is used on mobile, must not be combined with left/right arrows.
  - isInverted:         boolean   Determines if the carousel's style is inverted
  - counterDivider      string    Defines the divider in slides counter like (e.g., `1 / 5` or `1 of 5`)
  - hasEndingLoopGap    boolean   Determines if an extra gap is applied after the last element in loop carousel,
                                  to maintain uniform spacing throughout the carousel.
  - hasPlayButton       boolean   Determines if play/pause button is displayed
  - getPlayElement      function  Returns play button element
  - getPauseElement     function  Returns pause button element
*/

export const defaultConfig = {
  defaults: {
    align: 'start',
    hasArrows: false,
    hasDots: true,
    hasCounter: false,
    isInverted: false,
    isClipped: false,
    counterDivider: 'of',
    hasPlayButton: false,
    hasEndingLoopGap: true,
    playOnInit: false,
    delay: 3000,
    stopOnInteraction: false,
    stopOnFocusIn: false,
    getPlayElement: () => <>Play</>,
    getPauseElement: () => <>Pause</>,
    breakpoints: {
      s: {},
      m: {},
      l: {},
      xl: {},
      xxl: {},
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
